// extracted by mini-css-extract-plugin
export default {"label":"label-hDeZ8","formLabel":"formLabel-qK0jJ","row":"row-X6WjO"};